import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareBoardEmbedRoute: InvariantJiraRoute = {
	name: 'software-boards-embed',
	exact: true,
	path: '/jira/software/projects/:projectKey/boards/:boardId/embed',
};
